module.exports = __webpack_public_path__ + "static/ottobyyoox-2a730ecfe29462d2e306408fcb112a9c.jpg";